import React, { useEffect, useState } from 'react';

interface MenuProps {
  links: { label: string; href: string }[];
  isMobile?: boolean;
}

export const Menu: React.FC<MenuProps> = ({ links, isMobile }) => {
  const [isCompact, setIsCompact] = useState(false);

  const darkNavy = '#2c3e50';
  const emeraldGreen = '#58a08c';

  useEffect(() => {
    const onScroll = () => {
      setIsCompact(window.scrollY > 60);
    };

    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        background: isCompact
          ? 'rgba(255,255,255,0.95)'
          : 'rgba(255,255,255,0.85)',
        backdropFilter: isCompact ? 'blur(4px)' : 'blur(8px)',
        boxShadow: isCompact
          ? '0 1px 6px rgba(0,0,0,0.08)'
          : '0 2px 10px rgba(0,0,0,0.1)',
        transition: 'all 0.25s ease',
        zIndex: 1000
      }}
    >
      {/* Container anti-overflow */}
      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: isCompact
            ? isMobile
              ? '6px 12px'
              : '10px 24px'
            : isMobile
            ? '10px 15px'
            : '20px 32px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        {/* LOGO */}
        <img
          src={`${process.env.PUBLIC_URL}/ViZmerald_logo.png`}
          alt="ViZmerald"
          style={{
            height: isCompact
              ? isMobile
                ? '22px'
                : '34px'
              : isMobile
              ? '30px'
              : '50px',
            transition: 'height 0.25s ease'
          }}
        />

        {/* LINKS */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: isCompact
              ? isMobile
                ? '10px'
                : '16px'
              : isMobile
              ? '12px'
              : '24px',
            paddingTop: isCompact ? '2px' : '6px', // 👈 correction optique
            transition: 'all 0.25s ease'
          }}
        >
          {links.map(link => {
            const isHome = link.label.toLowerCase() === 'accueil';

            return (
              <a
                key={link.label}
                href={link.href}
                aria-label={link.label}
                style={{
                  color: darkNavy,
                  textDecoration: 'none',
                  fontWeight: 600,
                  fontSize: isCompact
                    ? isMobile
                      ? '0.8rem'
                      : '0.95rem'
                    : isMobile
                    ? '0.9rem'
                    : '1rem',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                {isHome ? (
                  /* HOME BUTTON */
                  <div
                    style={{
                      width: isCompact ? 34 : 40,
                      height: isCompact ? 34 : 40,
                      borderRadius: '50%',
                      background: darkNavy,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      transition: 'transform 0.2s ease, background 0.2s ease'
                    }}
                  >
                    <svg
                      width={isCompact ? 18 : 20}
                      height={isCompact ? 18 : 20}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#ffffff"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M3 10.5L12 3l9 7.5" />
                      <path d="M5 10v10a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1V10" />
                    </svg>
                  </div>
                ) : (
                  link.label
                )}
              </a>
            );
          })}
        </div>
      </div>
    </nav>
  );
};
